"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var InviteMember_module_css_1 = __importDefault(require("./InviteMember.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var q_play_components_2 = require("@nordicscreen/q-play-components");
var front_end_validation_1 = __importDefault(require("@nordicscreen/front-end-validation"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var react_bootstrap_1 = require("react-bootstrap");
var material_1 = require("@mui/material");
var q_play_core_1 = require("@nordicscreen/q-play-core");
function InviteMemberForm(_a) {
    var _this = this;
    var modal = _a.modal, onSuccess = _a.onSuccess;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var page = (0, useTypedPage_1.default)();
    var logger = q_play_core_1.logManager.getLogger();
    var defaultProps = { message: "" };
    var _b = (0, react_1.useState)(defaultProps), errors = _b[0], setError = _b[1];
    var form = (0, inertia_react_1.useForm)({
        email: "",
        qteams: []
    });
    var _c = (0, react_1.useState)([]), qteams = _c[0], setQteams = _c[1];
    (0, react_1.useEffect)(function () {
        var getQteams = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.getQteams()];
                    case 1:
                        response = _a.sent();
                        setQteams(response);
                        return [2 /*return*/];
                }
            });
        }); };
        getQteams();
    }, [page.props.user.language_format]);
    (0, react_1.useEffect)(function () {
        setError({ message: null });
        form.data.email = "";
        form.data.qteams = [];
    }, [modal.isShown]);
    var _d = (0, react_1.useState)(false), isLoading = _d[0], setIsLoading = _d[1];
    var onSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var profile, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setIsLoading(true);
                    profile = {
                        email: form.data.email,
                        qteams: form.data.qteams
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    new front_end_validation_1.default(profile.email).validate("should.be.email", t("Enter email address")).check();
                    setError({ message: null });
                    if (profile.qteams.length == 0) {
                        setError({ message: t("Choose at least one team") });
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, ApiManager_1.default.inviteUser(profile.email, profile.qteams)];
                case 2:
                    response = _a.sent();
                    if (typeof response.data.errors != "undefined") {
                        if (typeof response.data.errors.email != "undefined")
                            setError({ message: response.data.errors.email[0] });
                        else if (typeof response.data.errors.qteams != "undefined")
                            setError({ message: response.data.errors.qteams[0] });
                    }
                    else {
                        modal.toggle();
                        if (onSuccess)
                            onSuccess();
                    }
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    if (typeof e_1[0] === "undefined") {
                        logger.error("Error validating the request with email and qteams under InviteMember.tsx", e_1);
                        setError({ message: t("Something went wrong, our programmers have been notified") });
                    }
                    else {
                        setError({ message: e_1[0].message });
                    }
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var headline = t("Invite user");
    var body = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: InviteMember_module_css_1.default.bodyClass },
            react_1.default.createElement("div", { className: InviteMember_module_css_1.default.inputEmailContainer },
                react_1.default.createElement("h5", { className: InviteMember_module_css_1.default.subtitle }, t("Enter an email of the person you would like to invite")),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(q_play_components_2.Input, { placeholder: t("Enter email address"), type: "email", required: true, onChange: function (e) { form.data.email = e.currentTarget.value; }, autoFocus: true, className: InviteMember_module_css_1.default.standardValues }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("h3", { className: InviteMember_module_css_1.default.subtitle }, t("Add teams on a user")),
                react_1.default.createElement("div", { className: InviteMember_module_css_1.default.rolesContainer }, qteams === null || qteams === void 0 ? void 0 : qteams.map(function (qteam) {
                    return (react_1.default.createElement("div", { key: qteam.id, className: "d-flex align-items-center justify-content-between ns-font-family ns-font-size-14 ".concat(InviteMember_module_css_1.default.roleRow, " ").concat(InviteMember_module_css_1.default.standardValues) },
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { id: "qteam.".concat(qteam.id), className: InviteMember_module_css_1.default.checkboxContainer },
                            react_1.default.createElement(react_bootstrap_1.Form.Check.Label, { className: InviteMember_module_css_1.default.checkboxLabel },
                                react_1.default.createElement(material_1.Tooltip, { title: qteam.name, placement: "top", arrow: true },
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faQuestionCircle, color: "var(--info-color)", className: "".concat(InviteMember_module_css_1.default.questionCircle, " me-2 questionCircle") }))),
                                qteam.name),
                            react_1.default.createElement(react_bootstrap_1.Form.Check.Input, { type: "checkbox", value: qteam.id, className: InviteMember_module_css_1.default.roleCheckbox, onChange: function (e) {
                                    if (e.currentTarget.checked) {
                                        form.data.qteams.push(e.currentTarget.value);
                                    }
                                    else {
                                        var roleToRemove = form.data.qteams.indexOf(e.currentTarget.value);
                                        form.data.qteams.splice(roleToRemove, 1);
                                    }
                                } }))));
                }))))));
    var footer = (react_1.default.createElement("div", { className: InviteMember_module_css_1.default.popUpButtonContainer },
        errors.message ? react_1.default.createElement("span", { className: "text-danger m-2" }, errors.message) : null,
        isLoading && (react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-center", style: { width: "125px", height: "70px" } },
            react_1.default.createElement(q_play_components_1.Spinner, null))) || react_1.default.createElement(q_play_components_1.Button, { onClick: onSubmit, text: t("Invite") })));
    var featureDisabledBody = (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column" } },
        react_1.default.createElement("span", null, t("Invite disabled when using advanced SSO feature.")),
        react_1.default.createElement("span", null, t("You do not need to invite users, instead have them sign in using Microsoft SSO."))));
    var featureDisabledFooter = (react_1.default.createElement("div", null));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: modal.isShown, onClose: modal.toggle, headerText: headline, body: page.props.advanced_sso_enabled ? featureDisabledBody : body, footer: page.props.advanced_sso_enabled ? featureDisabledFooter : footer, dialogClassName: InviteMember_module_css_1.default.customModal, centered: true }));
}
exports.default = InviteMemberForm;
